module.exports = __webpack_public_path__ + "assets/img/04b822a279e1eae745848a66bdb3fcf0.png";